export default {
    upperCase(el, binding) {
        if(typeof el.value != 'undefined'){
            el.value = el.value.toUpperCase()
        }else{
            el.getElementsByTagName('input')[0].value = el.getElementsByTagName('input')[0].value.toUpperCase();
        }
    },
    inserted: function (el, binding) {
        binding.def.upperCase(el, binding);
    },
    componentUpdated: function (el, binding) {
        binding.def.upperCase(el, binding);
    },
}